<template>
    <b-card v-cloak class="property-wrapper">
        <template slot="header">
            <div class="d-flex justify-content-between mb-0">
                <div>
                    <h2 class="property-wrapper-padding">{{ $t('CURRENCY_SOURCE_SETUP') }}</h2>
                </div>
            </div>

            <Navigation :key="'reservation_process_currency'+componentKey"
                        :nav-elements="navElements">
            </Navigation>
        </template>

        <router-view>
        </router-view>
    </b-card>
</template>

<script>
import Navigation from "@/components/app/navigation/Navigation";
import {getDistribution, getDistributionList} from "@/services/distribution";
import routeNames from "@/router/routeNames";
export default {
    name: "Index",
    components: {Navigation},
    data() {
        return {
            componentKey: 1,
            distribution: null,
            distributionList: []
        }
    },
    methods: {
        async getDistributions() {
            await getDistributionList({company: this.company.id}).then(response => {
                this.distributionList = response.data
            });
        }
    },
    computed: {
        navElements() {
            return [
                {route: {name: routeNames.RN_SYSTEM_RESERVATION_CURRENCY_COMPANY}},
                // {route: {name: routeNames.RN_SYSTEM_RESERVATION_CURRENCY_PROPERTY}},
                {route: {name: routeNames.RN_SYSTEM_RESERVATION_CURRENCY_RATE_PLAN}},
            ]
        },
        backButton() {
            return {name: routeNames.RN_SETUP_GENERAL}
        },
        company() {
            return this.$store.getters['user/getCurrentCompany']
        },
    },
    watch: {
    },
    mounted() {
        this.$router.push({name: routeNames.RN_SYSTEM_RESERVATION_CURRENCY_COMPANY})
    }

}
</script>

<style scoped>

</style>
